import { BCMSStateManagerCRUD, BCMSValidate, ModalClose, StateManager, useStateManager, useWorkflow } from "@bcm-dev/bcms-vite";
import { ContactInfo } from "model";

import { FormContainer, FormRowView, LayoutContainer, LeftColumnContainer, RightColumnContainer } from 'components/shared';
import { FormButtonRow } from 'components/shared/containers/FormContainer';
import UINotifiButton from 'components/shared/notifi/UINotifiButton';
import { UITextInput } from 'components/ui';
import { SVGAsset } from 'res';
import ProgressionBarWidget, { ProgressionStep } from "../ProgressionBarWidget";

import "./styles.css";

export default function AddEmailContactView(props) {
    const data = { ...getDefaultViewData(), ...props.data ?? {} };
    const ui = { ...getDefaultViewUI(), ...props.ui ?? {} };

    const { nextStep, state: workflow } = useWorkflow() ?? {};

    const controller = (state, setState) => ({
        data: state.data,
        ui: state.ui,

        onSubmit: evt => {
            const info = state.data.info;

            info.value = BCMSValidate.isEmail(info.value) ? info.value : "sample@samplemail.com";
            info.type = "email";

            const workflowState = BCMSStateManagerCRUD.init(workflow)
                .update([ "data", "info" ], info)
                .update([ "data", "unconfirmedContacts" ], [ ...workflow.data.unconfirmedContacts, info ])
                .submit();

            nextStep(workflowState);
        },

        onChange: value => {
            BCMSStateManagerCRUD.init(state)
                .update([ "data", "info", "value" ], value)
                .submit(setState);
        }
    });

    return (
        <StateManager state={ { data, ui } } controller={ controller }>
            <AddEmailContactContent />
        </StateManager>
    );
}

export const getDefaultViewData = () => ({
    info: ContactInfo.init({}),
    unconfirmedContacts: []
});
export const getDefaultViewUI = () => ({});

function AddEmailContactContent(props) {
    const { data, onChange, onSubmit } = useStateManager();
    const btnIsDisabled = data.info.value.length > 0 ? "clickable" : "disabled";

    return (
        <LayoutContainer>
            <LeftColumnContainer>
                <div className="flex-container justify-right close-container mobile-container">
                    <ModalClose id="AddContactMethodModal" className="clickable text-right">
                        <SVGAsset id="CloseX" />
                    </ModalClose>
                </div>
                {/* The progression bar ui is updated here as the user navigates through the workflow. */}
                
                <ProgressionBarWidget>
                    <ProgressionStep activeClass="active" />
                    <ProgressionStep />
                </ProgressionBarWidget>

                <div className="add-email-contact-view">
                    <div className="flex-container flex-vertical all-center header-container text-center">
                        <h1>Add an Email contact</h1>
                        <h3>To get started, specify where you want to send Notifications to.</h3>
                    </div>
                    <FormContainer>
                        <FormRowView className="flex-horizontal align-center input-container email">
                            <SVGAsset id="EnvelopeIcon" className="envelope-icon" />
                            <UITextInput placeholder="Email Address" value={ data.info.value } onChange={ onChange } dataPoint="Add_Email_Contact_Field"/>
                        </FormRowView>
                        <FormButtonRow className="justify-right">
                            <UINotifiButton text="Next" onClick={ onSubmit } className={ btnIsDisabled } dataPoint="Next"/>
                        </FormButtonRow>
                    </FormContainer>
                </div>
            </LeftColumnContainer>

            <RightColumnContainer>
                <div className="flex-container justify-right close-container">
                    <ModalClose id="AddContactMethodModal" className="clickable">
                        <SVGAsset id="CloseX" />
                    </ModalClose>
                </div>
                <h2>What are notifications?</h2>
                <p>Notifications are a great way to stay on top of important things happening with your profile and accounts.</p>
                <p>You can turn on the notifications that matter most to you and personalize them to meet your needs.</p>
                <h2>Tip</h2>
                <div className="flex-container">
                    <div className="set-width">
                        <SVGAsset id="InfoIcon" className="icon info-icon" />
                    </div>
                    <div className="flex-width">
                        <p>You can add or change your contact info later in notifications Settings.</p>
                    </div>
                </div>
            </RightColumnContainer>
        </LayoutContainer>
    );
}